exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "details summary .fa-angle-double-down:before {\n    content: \"\\F055\";\n}\ndetails[open] summary .fa-angle-double-down:before {\n    content: \"\\F056\";\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/reviews/client-review.component.css
// module id = 1942
// module chunks = 0